var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main_treeview", attrs: { id: "monitor-menu" } },
    [
      _c("section", { staticClass: "menu_ctrl" }, [
        _c("span", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.$t("__monitor.top_hint")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "monitor_treeview" },
        [
          _vm.init_items.length > 0
            ? _c("TreeView", {
                ref: "child_treeview",
                attrs: {
                  current_tab: "monitor",
                  init_items: _vm.init_items,
                  checked_selectors: _vm.checked_selectors,
                  init_opened_layers: _vm.init_opened_layers,
                  check_function: _vm.change_monitor_type
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }